import { render, staticRenderFns } from "./PaginationNavigation.vue?vue&type=template&id=090c3a36&scoped=true&"
import script from "./PaginationNavigation.vue?vue&type=script&lang=js&"
export * from "./PaginationNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PaginationNavigation.vue?vue&type=style&index=0&id=090c3a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c3a36",
  null
  
)

export default component.exports